export const getters = {
    list: state => state.list,
    model: state => state.model,
    filter: state => state.filter,
    rules: state => state.rules,
    inventory: state => state.inventory,
    columns: state => state.columns,
};
